
export const tableRowStyle = {
  row: (props) => ({
    '&:hover': {
      backgroundColor: props.hover ? 'rgba(0, 0, 0, 0.04)' : ''
    }
  })
}
